import Vue from 'vue'
import Vuex from 'vuex'
import mobile from './mobile.js' // 移动端
Vue.use(Vuex)

export default new Vuex.Store({
  // 定义的公共变量
  state: {
    // 先去localStorage中获取数据
    user: window.localStorage.getItem('user') && window.localStorage.getItem('user') !== '' && window.localStorage.getItem('user') !== 'null' ? JSON.parse(window.localStorage.getItem('user')) : {},
    token: window.localStorage.getItem('token') || '',
    roleType: window.localStorage.getItem('user') && window.localStorage.getItem('user') !== '' && window.localStorage.getItem('user') !== 'null' ? ('0,1,2,3'.indexOf(JSON.parse(window.localStorage.getItem('user')).jslx) !== -1 ? 'admin' : 'other') : null, // 角色类型
    defaultActiveIndex: null
  },
  // state中的变量只能在mutations中通过方法修改
  mutations: {
    setUser (state, user) {
      if (user && user !== '') {
        // 将传递的数据先保存到localStorage中
        window.localStorage.setItem('user', JSON.stringify(user))
        // 之后才是修改state中的状态
        state.user = user
        state.roleType = '0,1,2,3'.indexOf(user.jslx) !== -1 ? 'admin' : 'other'
      } else {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', '')
        state.user = {}
        state.token = ''
        state.roleType = null
      }
    },
    setToken (state, token) {
      window.localStorage.setItem('token', token)
      state.token = token
    },
    changeDefaultActiveIndex (state, activeIndex) {
      state.defaultActiveIndex = activeIndex
    }
  },
  actions: {
  },
  modules: {
    mobile: mobile
  }
})
